import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Duration } from 'moment';

export function createDurationRangeValidator(): ValidatorFn {
  return (form: FormGroup): ValidationErrors | null => {
    const min: Duration = form.get('min').value;

    const max: Duration = form.get('max').value;

    if (min && max) {
      const isRangeValid = max.asMilliseconds() >= min.asMilliseconds();

      return isRangeValid ? null : { durationRange: true };
    }

    return null;
  };
}
